import { Route, Routes } from "react-router-dom";
import React from "react";
import LoginPage from "../pages/LoginPage.jsx";
import Authenticated from "../middleware/Authenticated.jsx";
import AuthLayout from "../layouts/AuthLayout.jsx";
import AdminLayout from "../layouts/AdminLayout.jsx";
import PermissionCheck from "../middleware/PermissionCheck.jsx";
import EmployeesPage from "../pages/EmployeesPage.jsx";
import AttendancePage from "../pages/AttendancePage.jsx";
import AttendanceSummaryPage from "../pages/AttendanceSummaryPage.jsx";
import LiveTrackingPage from "../pages/LiveTrackingPage.jsx";
import LeadsManagementPage from "../pages/lead/LeadsManagementPage.jsx";
import LeadDetailPage from "../pages/lead/LeadDetailPage.jsx";
import CustomersManagementPage from "../pages/customer/CustomersManagementPage.jsx";
import CustomerDetailPage from "../pages/customer/CustomerDetailPage.jsx";
import ZonesManagementPage from "../pages/zone/ZonesManagementPage.jsx";
import ZoneDetailPage from "../pages/zone/ZoneDetailPage.jsx";
import BanksManagementPage from "../pages/bank/BanksManagementPage.jsx";
import ServerPage from "../pages/server/ServerPage.jsx";
import ProjectsManagementPage from "../pages/project/ProjectsManagementPage.jsx";
import ProjectDetailPage from "../pages/project/ProjectDetailPage.jsx";
import ServiceManagementPage from "../pages/service/ServiceManagementPage.jsx";
import ItemCategoriesPage from "../pages/inventory/ItemCategoriesPage.jsx";
import ItemMasterPage from "../pages/inventory/ItemMasterPage.jsx";
import WarehousesPage from "../pages/inventory/WarehousesPage.jsx";
import StockLevelsPage from "../pages/inventory/StockLevelsPage.jsx";
import InitialStockPage from "../pages/inventory/InitialStockPage.jsx";
import InvoicesManagementPage from "../pages/invoice/InvoicesManagementPage.jsx";
import HandoverLettersManagementPage from "../pages/handover/HandoverLettersManagementPage.jsx";
import DashboardPage from "../pages/dashboard/DashboardPage.jsx";
import TicketsManagementPage from "../pages/support/TicketsManagementPage.jsx";
import TicketDetailPage from "../pages/support/TicketDetailPage.jsx";
import UsersManagementPage from "../pages/user/UsersManagementPage.jsx";

export const AppNavigator = () => {
  return (
    <Routes>
      <Route element={<Authenticated />}>
        <Route element={<AdminLayout />}>
          <Route element={<PermissionCheck />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/users" element={<UsersManagementPage />} />
            <Route path="/employees" element={<EmployeesPage />} />
            <Route path="/attendance-summary" element={<AttendanceSummaryPage />} />
            <Route path="/attendance" element={<AttendancePage />} />
            <Route path="/live-tracking" element={<LiveTrackingPage />} />
            <Route path="/leads" element={<LeadsManagementPage />} />
            <Route path="/leads/:id" element={<LeadDetailPage />} />
            <Route path="/customers" element={<CustomersManagementPage />} />
            <Route path="/customers/:id" element={<CustomerDetailPage />} />
            <Route path="/zones" element={<ZonesManagementPage />} />
            <Route path="/zones/:id" element={<ZoneDetailPage />} />
            <Route path="/banks" element={<BanksManagementPage />} />
            <Route path="/server" element={<ServerPage />} />
            <Route path="/projects" element={<ProjectsManagementPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/services" element={<ServiceManagementPage />} />

            <Route
              path="/inventory/categories"
              element={<ItemCategoriesPage />}
            />
            <Route path="/inventory/items" element={<ItemMasterPage />} />
            <Route path="/inventory/warehouses" element={<WarehousesPage />} />
            <Route path="/inventory/stock" element={<StockLevelsPage />} />
            <Route path="/inventory/initial-stock" element={<InitialStockPage />} />
            <Route path="/invoices" element={<InvoicesManagementPage />} />
            <Route path="/handover-letters" element={<HandoverLettersManagementPage />} />
            <Route path="/support-tickets" element={<TicketsManagementPage />} />
            <Route path="/support-tickets/:id" element={<TicketDetailPage />} />
          </Route>
        </Route>
      </Route>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
    </Routes>
  );
};
